import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";
import { WorkspaceRoleSchema } from "../../workspace";
import { DesignSystemRole } from "./ds-role";

export const DesignSystemInvitation = z.object({
  id: z.string(),
  designSystemId: z.string(),
  workspaceInvitationId: z.string(),
  designSystemRole: DesignSystemRole.optional(),
  workspaceRole: WorkspaceRoleSchema,
});

export type DesignSystemInvitation = z.infer<typeof DesignSystemInvitation>;

export type CreateDesignSystemInvitation = DbCreateInputOmit<DesignSystemInvitation>;
export type UpdateDesignSystemInvitation = OmitStrict<
  DbUpdate<DesignSystemInvitation>,
  "designSystemId" | "workspaceInvitationId"
>;
